import { useEffect, useState } from 'react';
import { LOCAL_STORAGE_CHANGE_EVENT } from '../constants/common';

const useLocalStorage = (key: string) => {
  const [value, setValue] = useState(localStorage.getItem(key) || '');

  useEffect(() => {
    setValue(localStorage.getItem(key) || '');

    const handleStorageChange = () => {
      if (value === localStorage.getItem(key)) return;
      setValue(localStorage.getItem(key) || '');
    };

    window.addEventListener(LOCAL_STORAGE_CHANGE_EVENT, handleStorageChange);
    return () => {
      window.removeEventListener(
        LOCAL_STORAGE_CHANGE_EVENT,
        handleStorageChange
      );
    };
  }, [key]);

  return value;
};

export default useLocalStorage;
